import { useState } from "react";
import { usePDF } from "react-to-pdf";

import { Box, Grid, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import { DefaultPaper, TextField } from "@aclymatepackages/atoms";

import Backdrop from "../atoms/mui/Backdrop";

const watermarkSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="200"><text x="50%" y="50%" transform="rotate(-30 200 100)" text-anchor="middle" font-size="48" font-family="Arial" font-weight="bold" fill="rgba(180,0,0,0.12)" dominant-baseline="middle">PRELIMINARY</text></svg>`;
const watermarkBg = `url("data:image/svg+xml,${encodeURIComponent(watermarkSvg)}")`;

const ReportLayout = ({
  ReportComponent,
  setShowReport,
  initialName,
  reportProps,
  isFinalized
}) => {
  const [pdfLoading, setPdfLoading] = useState(false);
  const [reportName, setReportName] = useState(`${initialName} Report`);
  const { targetRef, toPDF } = usePDF({
    filename: reportName,
    page: { format: "letter" }
  });

  const onExport = async () => {
    setPdfLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    toPDF();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return setPdfLoading(false);
  };

  return (
    <Backdrop
      style={{ overflowY: "hidden", zIndex: 1300 }}
      onClose={() => setShowReport(false)}
      boxStyle={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <Box mb={2}>
        <DefaultPaper>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <TextField
                value={reportName}
                setValue={(value) => setReportName(`${value}`)}
                variant="standard"
                style={{ width: "450px" }}
                InputProps={{ endAdornment: ".pdf" }}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                endIcon={<DownloadIcon />}
                onClick={onExport}
              >
                Download PDF
              </Button>
            </Grid>
          </Grid>
        </DefaultPaper>
      </Box>
      <Box flexGrow={1} style={{ overflowY: "scroll" }}>
        <Box ref={targetRef} style={{ position: "relative" }}>
          {<ReportComponent pdfLoading={pdfLoading} {...reportProps} />}
          {!isFinalized && (
            <Box
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundImage: watermarkBg,
                backgroundRepeat: "repeat",
                pointerEvents: "none",
                zIndex: 10
              }}
            />
          )}
        </Box>
      </Box>
    </Backdrop>
  );
};
export default ReportLayout;
